/**
 * "Değerlendirme yazın" butonunu Judge.me'nin kendi formuna bağlar.
 *
 * Judge.me'nin yorum formu bir modal ve o modal <body> altında, widget'tan
 * BAĞIMSIZ duruyor (doğrulandı). Bu yüzden widget'ı CSS ile gizleyip kendi
 * tasarımımızı gösterebiliyoruz; form çalışmaya devam ediyor.
 *
 * Buton varsayılan olarak gizli (hidden) başlar ve YALNIZCA Judge.me'nin
 * tetikleyicisi bulunduğunda açılır. Çalışmayan bir buton göstermektense
 * hiç göstermemek doğru — müşteri tıklayıp hiçbir şey olmamasından kötüsü yok.
 *
 * Judge.me betiği asenkron yüklendiği için tetikleyici sayfa açılışında
 * hazır olmayabiliyor; kısa bir süre gözlemleniyor.
 */
const YG_JM_TETIK = '.jm-action-buttons__button, .jdgm-write-rev-link';
const YG_BEKLEME_MS = 15000;

/**
 * Yorum yazma kapısı: adreste ?yorum=1 var mı?
 *
 * Amaç: "Değerlendirme yazın" butonunu ve boş yorum bölümünü YALNIZCA
 * bağlantıyı gönderdiğimiz kişiye göstermek. Mağaza sahibi WhatsApp veya
 * e-posta ile şu adresi yolluyor:
 *   .../products/<urun>?yorum=1
 * Sıradan ziyaretçi ürün sayfasında yorum yazma girişi görmüyor.
 *
 * Neden Liquid'de değil de burada: Shopify Liquid SORGU PARAMETRESİNİ
 * OKUYAMIYOR. request nesnesinde design_mode, host, locale, origin,
 * page_type, path var — query string YOK.
 *
 * Bu bir GÜVENLİK kapısı DEĞİL, bir kolaylık. Adresi bilen herkes
 * açabilir; açıldığında da yalnızca Judge.me'nin zaten herkese açık
 * formu görünür. Gizli veri yok.
 *
 * Tema editöründe her zaman açık — kapalı olsaydı buton editörde hiç
 * görünmez, dolayısıyla metni ve görünümü düzenlenemezdi.
 */
function ygKapiAcikMi() {
  if (new URLSearchParams(window.location.search).get('yorum') === '1') return true;
  if (window.Shopify && window.Shopify.designMode) return true;
  return false;
}

/**
 * Ürünün hiç yorumu yokken bölüm sunucudan `hidden` basılıyor
 * (sections/yg-reviews.liquid) — müşteri boş bir "MÜŞTERİ YORUMLARI"
 * bloğu görmesin diye. Kapı açıksa görünür kılınıyor.
 */
function ygGizliBolumuAc() {
  const bolum = document.querySelector('[data-yg-rev-gizli]');
  if (!bolum) return;
  if (!ygKapiAcikMi()) return;
  bolum.hidden = false;
}

function ygTetikBul() {
  return [...document.querySelectorAll(YG_JM_TETIK)].find((e) => e.offsetParent !== null || e.isConnected) ?? null;
}

function ygBagla(buton) {
  buton.hidden = false;
  buton.addEventListener('click', (olay) => {
    olay.preventDefault();
    olay.stopPropagation();

    // Iki savunma. Ikisi de UCUZ ve zarasiz; ikisi de kesin kanitlanmis bir
    // hatanin degil, bilinen kirilma bicimlerinin onlemi:
    //
    // 1) Tetik HER TIKLAMADA yeniden bulunuyor, baglanirken saklanmiyor.
    //    Judge.me widget'i Vue ile calisiyor; dugumu yeniden basarsa saklanan
    //    referans DOM'dan duserdi. (Olcumde dugum sabit cikti, yani bugun bu
    //    olmuyor — ama saklamanin bir faydasi da yok.)
    //
    // 2) stopPropagation + setTimeout: tetigi bu olayin ICINDE senkron
    //    cagirinca ayni tiklama document'a kadar yukselip Judge.me'nin
    //    "disari tiklandi" dinleyicisine yakalanabilir. Bir sonraki tick'e
    //    birakmak ikisini ayiriyor.
    //
    // Olculen davranis: temiz sayfa + tek tiklama guvenilir sekilde aciyor.
    // Kapat-hemen-tekrar-ac dizisinde (700ms) kararsizlik gorulduk; bu
    // Judge.me'nin kapanma durumuyla ilgili ve gercek kullanim oruntusu degil.
    setTimeout(() => {
      const t = ygTetikBul();
      if (t) t.click();
    }, 0);
  });
}

function ygBaslat() {
  ygGizliBolumuAc();

  // Kapı kapalıysa buton hidden kalır. Judge.me tetikleyicisi aranmaz bile:
  // gösterilmeyecek bir buton için MutationObserver kurmanın anlamı yok.
  if (!ygKapiAcikMi()) return;

  const buton = document.querySelector('[data-yg-rev-write]');
  if (!buton) return;

  const hemen = ygTetikBul();
  if (hemen) {
    ygBagla(buton);
    return;
  }

  const gozlemci = new MutationObserver(() => {
    const t = ygTetikBul();
    if (!t) return;
    gozlemci.disconnect();
    ygBagla(buton);
  });
  gozlemci.observe(document.body, { childList: true, subtree: true });

  // Judge.me hic yuklenmezse gozlemciyi surekli acik birakma.
  setTimeout(() => gozlemci.disconnect(), YG_BEKLEME_MS);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ygBaslat, { once: true });
} else {
  ygBaslat();
}
